import { heroBannerSlice } from './single-slice-helpers/heroBannerSlice';
import { sliceTrustedByBarSlice } from './single-slice-helpers/sliceTrustedByBarSlice';
import { featuresSlice } from './single-slice-helpers/featuresSlice';
import { statsSlice } from './single-slice-helpers/statsSlice';
import { textBlockSlice } from './single-slice-helpers/textBlockSlice';
import { singleMediaSlice } from './single-slice-helpers/singleMediaSlice';
import { multipleMediaSlice } from './single-slice-helpers/multipleMediaSlice';
import { PrismicDocumentHelper } from "../PrismicHelpers";
import {
	testimonialsSliceArray,
	testimonialsSliceRelationship,
} from './single-slice-helpers/testimonialsSlice';
import {
	packagesSliceArray,
	productsSliceArray,
	packagesSliceRelationship,
	productsSliceRelationship,
} from './single-slice-helpers/productsSlice';
// just on privacy policy page right now
import { tableSlice } from './single-slice-helpers/tableSlice';
import {
	bigVideoSlice,
	bigVideoSliceWithCopy,
	subtitleSlice,
} from './single-slice-helpers/bigVideoSlice';
import {
	eventsSlice,
	eventsSliceRelationship,
} from './single-slice-helpers/eventsSlice';
import {
	coursesSlice,
	coursesSliceRelationship,
} from './single-slice-helpers/coursesSlice';

// Remove null from array (locally when testing)
function filter_array(test_array) {
	var index = -1,
		arr_length = test_array ? test_array.length : 0,
		resIndex = -1,
		result = [];
	while (++index < arr_length) {
		var value = test_array[index];
		if (value) {
			result[++resIndex] = value;
		}
	}
	return result;
}
//OLD - Will remove when all references in components have been updated.
export const prismicSliceHelper = response => {
	// Check if navbar/footer
	// Take SEO object
	// Take all slices data [array]
	const sliceData = response.results[0].data.body;
	// Create new empty array [] -> it will be displayed and returned to front-end
	let arrayOfSlices = [];
	// Slice data -> take te exact data we need and leave it in array (good order)
	arrayOfSlices = sliceData.map(slice => {
		if (
			slice.slice_type === 'hero_banner' ||
			slice.slice_type === 'hero_-_header'
		)
			return heroBannerSlice(slice);
		if (slice.slice_type === 'trusted_by_bar')
			return sliceTrustedByBarSlice(slice);
		if (slice.slice_type === 'testimonials')
			return testimonialsSliceArray(slice);
		if (slice.slice_type === 'features_block') return featuresSlice(slice);
		//if (slice.slice_type === 'faq_slice')  return faqSliceArray(slice)
		if (slice.slice_type === 'packages') return packagesSliceArray(slice);
		if (slice.slice_type === 'stats_block') return statsSlice(slice);
		if (slice.slice_type === 'text_block') return textBlockSlice(slice);
		if (slice.slice_type === 'single_media_block')
			return singleMediaSlice(slice);
		if (slice.slice_type === 'multiple_media_blocks')
			return multipleMediaSlice(slice);
		if (slice.slice_type === 'single_product_listing')
			return productsSliceArray(slice);
		//if (slice.slice_type === 'jobs_carousel')  return jobsCarouselSlice(slice)
		//if (slice.slice_type === 'advertisement')  return advertisementSlice(slice)
		if (slice.slice_type === 'table') return tableSlice(slice);
		if (slice.slice_type === 'big_video') return bigVideoSlice(slice);
		if (slice.slice_type === 'big_video_with_copy')
			return bigVideoSliceWithCopy(slice);
		if (slice.slice_type === 'events') return eventsSlice(slice);
		if (slice.slice_type === 'subtitle') return subtitleSlice(slice);
	});
	// Filter locally if there is no null (for example testimonials without any testimonials)
	arrayOfSlices = filter_array(arrayOfSlices);
	// All data to return to front-end
	const dataToReturn = {
		slices: arrayOfSlices,
	};
	// Watch the world burn!! :D
	return dataToReturn;
};
//NEW - slices helper to be used, will remove the previous helper above once all references to it have
export const prismicSlicesHelper = response => {
	const sliceData = response[0].data.body;
	let arrayOfSlices = [];
	arrayOfSlices = sliceData.map(slice => {
		switch (slice.slice_type) {
			case 'hero_banner':
				return heroBannerSlice(slice);
			case 'hero_-_header':
				return heroBannerSlice(slice);
			case 'trusted_by_bar':
				return sliceTrustedByBarSlice(slice);
			case 'testimonials':
				return testimonialsSliceArray(slice);
			case 'features_block':
				return featuresSlice(slice);
			case 'packages':
				return packagesSliceArray(slice);
			case 'stats_block':
				return statsSlice(slice);
			case 'text_block':
				return textBlockSlice(slice);
			case 'single_media_block':
				return singleMediaSlice(slice);
			case 'multiple_media_blocks':
				return multipleMediaSlice(slice);
			case 'single_product_listing':
				return productsSliceArray(slice);
			case 'table':
				return tableSlice(slice);
			case 'big_video':
				return bigVideoSlice(slice);
			case 'events':
				return eventsSlice(slice);
			case 'single-events':
				return eventsSlice(slice);
			case 'course_modules':
				return coursesSlice(slice);
			default:
				return false;
		}
	});
	arrayOfSlices = filter_array(arrayOfSlices);
	const dataToReturn = {
		slices: arrayOfSlices,
	};
	return dataToReturn;
};
//OLD - Keep this until all references in components are updated
export const prismicSliceContentRelationship = async (
	slices,
	PrismicConnection
) => {
	try {
		// Check for slice type and if IDs is longer than 0 -> return correct data or return slice
		slices = slices.map(async slice => {
			if (slice.type === 'testimonials' && slice.testimonials.length > 0)
				return testimonialsSliceRelationship(
					await PrismicConnection.getByIDs(slice.testimonials),
					slice.type
				);
			if (slice.type === 'events' && slice.events.length > 0)
				return eventsSliceRelationship(
					await PrismicDocumentHelper('document.type', 'single-event', false, 'at'),
					slice.type
				);
			if (slice.type === 'packages' && slice.packages.length > 0)
				return packagesSliceRelationship(
					await PrismicConnection.getByIDs(slice.packages),
					slice.packagesWithRecommended,
					slice.type
				);
			if (slice.type === 'single_product_listing' && slice.products.length > 0)
				return productsSliceRelationship(
					await PrismicConnection.getByIDs(slice.products),
					slice.productBgColour,
					slice.type
				);
			//if (slice.type === 'faq_slice' && slice.faqs.length > 0) return faqSliceRelationship(await PrismicConnection.getByIDs(slice.faqs), slice.type, slice);
			//if (slice.type === 'advertisement' && slice.id.length > 0) return advertisementSliceRelationship(await PrismicConnection.getByID(slice.id), slice.type);
			return slice;
		});
		slices = await Promise.all(slices);
		slices = filter_array(slices);
		return slices;
	} catch (err) {
		return { error: true };
	}
};
//NEW slices content relationship - will remove the previous version (if statements) when all references have been removed.
export const prismicSlicesContentRelationship = async (
	slices,
	PrismicConnection
) => {
	try {
		// Check for slice type and if IDs is longer than 0 -> return correct data or return slice
		slices = slices.map(async slice => {
			switch (slice.type) {
				case 'testimonials':
					return testimonialsSliceRelationship(
						await PrismicConnection.getByIDs(slices.testimonials),
						slice.type
					);
				case 'events':
					return eventsSliceRelationship(
						await PrismicConnection.getByIDs(slices.events),
						slice.type
					);
				case 'packages':
					return packagesSliceRelationship(
						await PrismicConnection.getByIDs(slices.packages),
						slice.packagesWithRecommended,
						slice.type
					);
				case 'single_product_listing':
					return productsSliceRelationship(
						await PrismicConnection.getByIDs(slice.products),
						slice.productBgColour,
						slice.type
					);
				case 'course_modules':
					return coursesSliceRelationship(
						await PrismicConnection.getByIDs(slice.modules),
						slice.type
					);
				default:
					return false;
			}
		});
		slices = await Promise.all(slices);
		slices = filter_array(slices);
		return slices;
	} catch (err) {
		return { error: true };
	}
};
//add padding top and bottom
export const sectionPaddingClasses = function(margins) {
	let names = [];
	if (margins === 'Top and bottom margins')
		names.push('padding-top-large', 'padding-bottom-large');
	if (margins === 'Top margin only') names.push('padding-top-large');
	if (margins === 'Bottom margin only') names.push('padding-bottom-large');
	if (margins === 'No margins') names.push('');
	return names.join(' ');
};



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers.js